/**
 * @generated SignedSource<<b0d26a273fc0238eba7d9587381fd373>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditMainPresentation_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CategoriesSelect_data" | "LabelsSelect_data" | "WhatToSeeSelect_data">;
  readonly " $fragmentType": "PackageEditMainPresentation_data";
};
export type PackageEditMainPresentation_data$key = {
  readonly " $data"?: PackageEditMainPresentation_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditMainPresentation_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditMainPresentation_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CategoriesSelect_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LabelsSelect_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WhatToSeeSelect_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "cc426bff18f98f3ad3452027c92907b7";

export default node;
